<template>
    <v-avatar
            :size="size || '120px'"
            color="primary lighten-1"
            class="ma-2"
    >
        <v-img
                v-if="imageUrl"
                :src="imageUrl"
                alt="Avatar"
        />
        <v-icon v-if="!imageUrl" :size="size || '120px'" large color="white">account_circle</v-icon>
    </v-avatar>
</template>

<script>
    export default{
        props: ['imageUrl', 'size']
    }
</script>